// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__35YiM","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3wIBR","gfeWrapper":"CalendarEvent_gfeWrapper__3hHAg"};